"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var baseStyle = {
  width: "var(--spinner-size)",
  height: "var(--spinner-size)"
};
var sizes = {
  xs: {
    "--spinner-size": "0.75rem"
  },
  sm: {
    "--spinner-size": "1rem"
  },
  md: {
    "--spinner-size": "1.5rem"
  },
  lg: {
    "--spinner-size": "2rem"
  },
  xl: {
    "--spinner-size": "3rem"
  }
};
var defaultProps = {
  size: "md"
};
var _default = {
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
exports["default"] = _default;
//# sourceMappingURL=spinner.js.map